import script from "./UploadFileComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadFileComponent.vue?vue&type=script&setup=true&lang=js"

import "./UploadFileComponent.vue?vue&type=style&index=0&id=99819156&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99819156"]])

export default __exports__